"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var SETTINGS_APPID = 'pulse';
var SETTINGS_GROUPID = 'notifications';
var METHOD = {
  GET: 'GET',
  POST: 'POST'
};
/**
 * In the page lifecycle, there can be at most 2 objects existing for
 * this Service i.e, 1 for Flyout and 2nd for View All.
 * But the context of ViewAll will be in an iframe, so keeping the service
 * as Singleton.
 */

var SettingsService = {
  service: undefined,
  isViewAll: false,

  /**
   * This function will bind the Object with settingService
   * provided in page runtime.
   *
   * @param configuration
   */
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  configure: function configure(configuration) {
    var settingsService = configuration.settingsService,
        viewAll = configuration.viewAll;
    SettingsService.service = settingsService;
    SettingsService.isViewAll = !!viewAll;
    return SettingsService;
  },

  /**
   * This function will update the user settings
   * based on the container component either View All/Flyout.
   *
   * @param settings
   */
  updateUserSettings: function () {
    var _updateUserSettings = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee(settings) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (SettingsService.service) {
                _context.next = 2;
                break;
              }

              throw new Error('Init Settings failed: Missing configuration');

            case 2:
              _context.prev = 2;

              if (!SettingsService.isViewAll) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return SettingsService.service.set({
                groupId: SETTINGS_GROUPID,
                settings: settings
              });

            case 6:
              _context.next = 10;
              break;

            case 8:
              _context.next = 10;
              return SettingsService.service.settingsHandler({
                groupId: SETTINGS_GROUPID,
                settings: settings
              }, METHOD.POST, false, SETTINGS_APPID);

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              console.log('SettingsService : UpdateUserSettings failed ', _context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 12]]);
    }));

    function updateUserSettings(_x) {
      return _updateUserSettings.apply(this, arguments);
    }

    return updateUserSettings;
  }(),

  /**
   * TODO: Need to do strict typing.
   */

  /**
   * This function will return the user setting
   * received from page runtime.
   *
   * @param data
   */
  getUserSettings: function () {
    var _getUserSettings = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee2() {
      var data,
          response,
          settings,
          keys,
          _args2 = arguments;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              data = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};

              if (SettingsService.service) {
                _context2.next = 3;
                break;
              }

              throw new Error('Init Settings failed: Missing configuration');

            case 3:
              // setting default/fallback values to null.
              // In cases of failed backend calls, the response received contains default/fallback values.
              settings = {
                lastClickTimestamp: null,
                lastSeenAnnouncementsTimestamp: null,
                lastNotificationSeenTimestamp: null
              };
              _context2.prev = 4;

              if (!SettingsService.isViewAll) {
                _context2.next = 12;
                break;
              }

              _context2.next = 8;
              return SettingsService.service.get({
                groupId: SETTINGS_GROUPID,
                settings: settings
              });

            case 8:
              response = _context2.sent;
              return _context2.abrupt("return", response && response.settings);

            case 12:
              if (!(!data || typeof data === 'undefined' || Object.keys(data).length === 0 && data.constructor === Object)) {
                _context2.next = 19;
                break;
              }

              _context2.next = 15;
              return SettingsService.service.settingsHandler({
                groupId: SETTINGS_GROUPID,
                settings: settings
              }, METHOD.GET, false, SETTINGS_APPID);

            case 15:
              response = _context2.sent;
              return _context2.abrupt("return", response && response.settings);

            case 19:
              // else part where input object is not empty hence not making a settings call.
              keys = Object.keys(settings);
              keys && keys.forEach(function (key) {
                if (!data.settings[key]) {
                  data.settings[key] = settings[key];
                }
              });
              return _context2.abrupt("return", data.settings);

            case 22:
              _context2.next = 27;
              break;

            case 24:
              _context2.prev = 24;
              _context2.t0 = _context2["catch"](4);
              console.log('SettingsService : GetUserSettings failed ', _context2.t0);

            case 27:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 24]]);
    }));

    function getUserSettings() {
      return _getUserSettings.apply(this, arguments);
    }

    return getUserSettings;
  }()
};
var _default = SettingsService;
exports.default = _default;